
export const GET_PRODUCT_LIST = 'GET_PRODUCT_LIST';
export const GET_CART_LIST = 'GET_CART_LIST';
export const GET_CATEGORY_LIST = 'GET_CATEGORY_LIST';
export const GET_RATING_LIST = 'GET_RATING_LIST';
export const GET_BRAND_LIST = 'GET_BRAND_LIST';

export const ADD_PRODUCT_TO_CART = 'ADD_PRODUCT_TO_CART';
export const DELETE_PRODUCT_FROM_CART = 'DELETE_PRODUCT_FROM_CART';

export const UPDATE_CART_AMOUNT = 'UPDATE_CART_AMOUNT';


export const GET_USER_NAVIGATION_PENDING = 'GET_USER_NAVIGATION_PENDING'
export const GET_USER_NAVIGATION_SUCCESS = 'GET_USER_NAVIGATION_SUCCESS'
export const GET_USER_NAVIGATION_FAILED = 'GET_USER_NAVIGATION_FAILED'


export const GET_NOTIFICATION = 'GET_NOTIFICATION'
export const CREATE_NOTIFICATION = 'CREATE_NOTIFICATION'
export const DELETE_NOTIFICATION = 'DELETE_NOTIFICATION'
export const DELETE_ALL_NOTIFICATION = 'DELETE_ALL_NOTIFICATION'


export const GET_ALL_BOARD = 'GET_ALL_BOARD'
export const GET_BOARD_BY_ID = 'GET_BOARD_BY_ID'
export const ADD_BOARD = 'ADD_BOARD'
export const ADD_MEMBER_IN_BOARD = 'ADD_MEMBER_IN_BOARD'
export const DELETE_MEMBER_FROM_BOARD = 'DELETE_MEMBER_FROM_BOARD'
export const GET_ALL_MEMBERS = 'GET_ALL_MEMBERS'
export const GET_ALL_LABELS = 'GET_ALL_LABELS'

export const ADD_LIST = 'ADD_LIST'
export const RENAME_LIST = 'RENAME_LIST'
export const REORDER_LIST = 'REORDER_LIST'
export const DELETE_LIST = 'DELETE_LIST'

export const ADD_CARD = 'ADD_CARD'
export const UPDATE_CARD = 'UPDATE_CARD'
export const REORDER_CARD = 'REORDER_CARD'
export const REORDER_CARD_LIST = 'REORDER_CARD_LIST'
export const MOVE_CARD = 'MOVE_CARD'
export const DELETE_CARD = 'DELETE_CARD'





export const UPDATE_LANDING_ACTIVE_TAB = 'UPDATE_LANDING_ACTIVE_TAB'

export const OPEN_POPUP = 'OPEN_POPUP'
export const CLOSE_POPUP = 'CLOSE_POPUP'

export const GET_TABLE_LISTING_PENDING = 'GET_TABLE_LISTING_PENDING'
export const GET_TABLE_LISTING_SUCCESS = 'GET_TABLE_LISTING_SUCCESS'
export const GET_TABLE_LISTING_FAILED = 'GET_TABLE_LISTING_FAILED'

export const GET_ITEM_DETAILS_PENDING = 'GET_ITEM_DETAILS_PENDING'
export const GET_ITEM_DETAILS_SUCCESS = 'GET_ITEM_DETAILS_SUCCESS'
export const GET_ITEM_DETAILS_FAILED = 'GET_ITEM_DETAILS_FAILED'

export const UPDATE_TABLE_LISTING = 'UPDATE_TABLE_LISTING'

export const UPDATE_ITEM_DETAILS = 'UPDATE_ITEM_DETAILS'
export const UPDATE_ITEM_DETAILS_SUCCESS = 'UPDATE_ITEM_DETAILS_SUCCESS'

export const IMPORT_ITEM_DETAILS_SUCCESS = 'IMPORT_ITEM_DETAILS_SUCCESS'